module.exports = __webpack_public_path__ + "static/media/2@3x.032cc4ff.png";